<div
  dgxUploader
  (fileDropped)="onImageSelected($event)"
  (dragState)="onChangeDragState($event)"
  class="logo-uploader simple-pic-wrap simple-pic-wrap--org hide-preview rel"
  [ngStyle]="{ 'background-color': brandingData.hexBrand }"
  [ngClass]="{
    'simple-pic-wrap--no-image-org': !brandingData.orgImage,
    'logo-uploader--active': uploaderFocused
  }"
>
  <div class="image-edit">
    <label class="image-edit-wrap center-text">
      <img
        alt="{{ brandingData.org.name }}"
        src="{{ brandingData.srcSet.retina }}"
        attr.srcset="{{ brandingData.srcSet.orig }} 1x, {{
          brandingData.srcSet.retina
        }} 2x"
        *ngIf="brandingData.orgImage"
        data-dgat="orgSettings-9b2"
      />
      <input
        type="file"
        #inputRef
        id="inputRef"
        class="hidden-without-display"
        (change)="onImageSelected($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        [attr.aria-label]="changeText"
        data-dgat="org-branding-d25"
      />
      <span
        class="par--small mage-edit-trigger image-edit-trigger--bottom"
        data-dgat="orgOverview-2de"
      >
        {{ changeText }}
      </span>
    </label>
  </div>
</div>
